import { IconVariant } from '@/components/icons/types';

export enum ButtonIdentifier {
  Profile = 'profile',
  Bookings = 'bookings',
  Favorites = 'favorites',
  LogIn = 'user_log_in',
  ConnectCompany = 'b2b',
  CompanyLogin = 'merchant',
  Back = 'back',
}

export type Button = {
  id?: string;
  icon?: IconVariant;
  label?: string;
  to?: string;
  className?: string;
  identifier: ButtonIdentifier;
  breakpoint?: string;
};
